import script from "./section.vue?vue&type=script&setup=true&lang=js"
export * from "./section.vue?vue&type=script&setup=true&lang=js"

import "./section.vue?vue&type=style&index=0&id=25b403da&lang=scss"

const __exports__ = script;

export default __exports__